export default (value) => {
  const options = {
    year: "numeric",
    month: "short",
    day: "2-digit",
  };
  return new Date(value).toLocaleDateString("en-GB", options);
};
